import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
    const { login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const from = new URLSearchParams(location.search).get("next") || "/account";

    const onSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            const user = await login(email, password);
            navigate(user.role === "admin" || user.role === "staff" ? "/admin" : from);
        } catch (e) {
            setErr(formatApiError(e.response?.data?.detail) || e.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page" data-testid="login-page">
            <div className="eyebrow" style={{ marginBottom: 12 }}>Sign In</div>
            <h1>Welcome back.</h1>
            <p>Sign in to view your orders and consignments.</p>
            <form className="auth-form" onSubmit={onSubmit} data-testid="login-form">
                <div className="field">
                    <label className="label" htmlFor="li-email">Email</label>
                    <input
                        id="li-email"
                        type="email"
                        className="input"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        data-testid="login-email"
                    />
                </div>
                <div className="field">
                    <label className="label" htmlFor="li-pass">Password</label>
                    <input
                        id="li-pass"
                        type="password"
                        className="input"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        data-testid="login-password"
                    />
                </div>
                {err && <div className="form-error" data-testid="login-error">{err}</div>}
                <button className="btn" type="submit" disabled={loading} data-testid="login-submit">
                    {loading ? "Signing in…" : "Sign In"}
                </button>
                <div className="alt">
                    New here?{" "}
                    <Link to="/register" className="link-underline" data-testid="login-register-link">
                        Create an account
                    </Link>
                </div>
            </form>
        </div>
    );
}
